var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _rect5, _rect6, _rect7, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 31,
    width: 200,
    height: 200,
    rx: 16,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 75C63 68.3726 68.3726 63 75 63H231V231H63V75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107 97C101.49 97 97 101.49 97 107C97 112.51 101.49 117 107 117C112.51 117 117 112.51 117 107C117 101.49 112.51 97 107 97ZM111.78 104.7L106.11 110.37C105.97 110.51 105.78 110.59 105.58 110.59C105.38 110.59 105.19 110.51 105.05 110.37L102.22 107.54C101.93 107.25 101.93 106.77 102.22 106.48C102.51 106.19 102.99 106.19 103.28 106.48L105.58 108.78L110.72 103.64C111.01 103.35 111.49 103.35 111.78 103.64C112.07 103.93 112.07 104.4 111.78 104.7Z",
    fill: "#9CD323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 95,
    width: 100,
    height: 5,
    rx: 2.5,
    fill: "#C3D4E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 112,
    width: 100,
    height: 5,
    rx: 2.5,
    fill: "#C3D4E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 129,
    width: 100,
    height: 5,
    rx: 2.5,
    fill: "#C3D4E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107 160C101.49 160 97 164.49 97 170C97 175.51 101.49 180 107 180C112.51 180 117 175.51 117 170C117 164.49 112.51 160 107 160ZM111.78 167.7L106.11 173.37C105.97 173.51 105.78 173.59 105.58 173.59C105.38 173.59 105.19 173.51 105.05 173.37L102.22 170.54C101.93 170.25 101.93 169.77 102.22 169.48C102.51 169.19 102.99 169.19 103.28 169.48L105.58 171.78L110.72 166.64C111.01 166.35 111.49 166.35 111.78 166.64C112.07 166.93 112.07 167.4 111.78 167.7Z",
    fill: "#9CD323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 158,
    width: 100,
    height: 5,
    rx: 2.5,
    fill: "#C3D4E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 175,
    width: 100,
    height: 5,
    rx: 2.5,
    fill: "#C3D4E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 192,
    width: 100,
    height: 5,
    rx: 2.5,
    fill: "#C3D4E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 28,
    fill: "#8F03ED",
    stroke: "#F3F4F6",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6488 40.324C29.7928 40.324 28.9888 40.164 28.2368 39.844C27.4848 39.516 26.8328 39.052 26.2808 38.452C25.7368 37.852 25.3408 37.144 25.0928 36.328L27.5168 35.656C27.7488 36.4 28.1528 36.972 28.7288 37.372C29.3048 37.764 29.9448 37.956 30.6488 37.948C31.2808 37.94 31.8368 37.792 32.3168 37.504C32.7968 37.216 33.1728 36.828 33.4448 36.34C33.7168 35.844 33.8528 35.276 33.8528 34.636C33.8528 33.676 33.5528 32.884 32.9528 32.26C32.3608 31.636 31.5848 31.324 30.6248 31.324C30.3528 31.324 30.0728 31.364 29.7848 31.444C29.5048 31.524 29.2408 31.628 28.9928 31.756L27.8168 29.776L33.9128 24.388L34.1768 25.108H25.7768V22.72H36.1688V25.108L31.1048 29.98L31.0808 29.164C32.1688 29.164 33.1128 29.408 33.9128 29.896C34.7128 30.376 35.3288 31.032 35.7608 31.864C36.2008 32.688 36.4208 33.612 36.4208 34.636C36.4208 35.74 36.1608 36.72 35.6408 37.576C35.1288 38.432 34.4368 39.104 33.5648 39.592C32.7008 40.08 31.7288 40.324 30.6488 40.324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep03);
export default __webpack_public_path__ + "static/media/Step03.0c8d2a0d6b2562c52cc5d34e00352498.svg";
export { ForwardRef as ReactComponent };